module.exports = __webpack_public_path__ + "static/email-template-account-activation-robolly-a4f3399cc034e66e73386162d4cfd73e.jpg";